import Link from 'next/link'
import React from 'react'
import Image from 'next/image'
function Topfooter({ footerData, footerDescription }) {
  return (
    <>
      {/* TOP FOOTER  */}
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto  py-8 grid grid-cols-1 md:grid-cols-7 gap-4">

        {/* LEFT SIDE */}
        <div className="col-span-1 md:col-span-2 space-y-6">
          <a href="/">
            <Image
              src="/logo.svg"
              alt="Medhavi Skills University"
              width={218}
              height={72}
              className="lg:h-14 xl:h-16 2xl:h-18 w-auto mb-4"
            />
          </a>

          <p className="footer-about-text text-gray-300">
            {footerDescription}
          </p>

          {/* Social Icons from JSON */}
          {/* <div className="flex gap-4 text-2xl">
            {footerData.socialLinks.map((item, index) => (
              <Link
                key={index}
                href={item.url}
                target="_blank"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10
                           hover:bg-white/20 transition cursor-pointer"
              >
                <i className={item.icon}></i>
              </Link>
            ))}
          </div> */}
        </div>

        {/* FOOTER MENUS (About, Academics, Quick Links) */}
        {footerData.footerMenus.map((menu, index) => (
          <div key={index}>
            <p className="footer-heading mb-4">{menu.title}</p>

            <ul className="space-y-2">
              {menu.links.map((link, i) => (
                <li key={i}>
                  <Link
                    href={link.slug}
                    prefetch={false}
                    className="footer-link text-gray-300 hover:text-white transition cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

      </div>

    </>
  )
}

export default Topfooter